//@ts-check
//@ts-ignore
import Password from './password.riot';
import { router } from '@riotjs/route';
import { changeRequestRequest, changeRequestSuccess, changeRequestFailure } from './password.action';
import { ajaxPost } from '../ajax';
import { connect } from '@/common/lib/riot-redux';

const mapDispatchToProps = (dispatch) => ({
  async changeRequest(payload) {
    dispatch(changeRequestRequest());
    try {
      await ajaxPost('/password', {
        method: 'changeRequest',
        mail: payload.mail
      });
      await dispatch(changeRequestSuccess());
      router.push('result');
    } catch (e) {
      dispatch(changeRequestFailure(e));
    }
  }
});

export default connect(Password, null, mapDispatchToProps);